import { explorerUrl } from '../../lib/tx'

export type TradeResult =
  | { kind: 'idle' }
  | { kind: 'pending'; label: string }
  | { kind: 'success'; signature: string; summary: string }
  | { kind: 'error'; message: string }

interface Props {
  result: TradeResult
  onDismiss?: () => void
}

export default function TradeResultBanner({ result, onDismiss }: Props) {
  if (result.kind === 'idle') return null

  if (result.kind === 'pending') {
    return (
      <div className="flex items-center gap-3 rounded-lg border border-accent-yellow/30 bg-accent-yellow/10 px-3 py-2 text-xs text-accent-yellow">
        <span className="h-3 w-3 animate-spin rounded-full border-2 border-accent-yellow/30 border-t-accent-yellow" />
        <span>{result.label}</span>
      </div>
    )
  }

  if (result.kind === 'success') {
    return (
      <div className="flex items-start gap-3 rounded-lg border border-accent-green/30 bg-accent-green/10 px-3 py-2 text-xs text-accent-green">
        <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" className="mt-0.5 h-4 w-4 shrink-0">
          <polyline points="3,8 7,12 13,4" />
        </svg>
        <div className="flex-1 min-w-0">
          <div className="font-semibold">{result.summary}</div>
          <a
            href={explorerUrl(result.signature)}
            target="_blank"
            rel="noopener noreferrer"
            className="break-all text-[10px] text-accent-green/80 hover:underline"
          >
            {result.signature.slice(0, 32)}… · solscan ↗
          </a>
        </div>
        {onDismiss && (
          <button onClick={onDismiss} className="text-accent-green/60 hover:text-accent-green" aria-label="Dismiss">
            <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" className="h-3 w-3">
              <line x1="3" y1="3" x2="13" y2="13" /><line x1="13" y1="3" x2="3" y2="13" />
            </svg>
          </button>
        )}
      </div>
    )
  }

  return (
    <div className="flex items-start gap-3 rounded-lg border border-accent-red/30 bg-accent-red/10 px-3 py-2 text-xs text-accent-red">
      <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" className="mt-0.5 h-4 w-4 shrink-0">
        <circle cx="8" cy="8" r="6" /><line x1="8" y1="5" x2="8" y2="9" /><line x1="8" y1="11" x2="8" y2="11.5" />
      </svg>
      <span className="flex-1 break-words">{result.message}</span>
      {onDismiss && (
        <button onClick={onDismiss} className="text-accent-red/60 hover:text-accent-red" aria-label="Dismiss">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" className="h-3 w-3">
            <line x1="3" y1="3" x2="13" y2="13" /><line x1="13" y1="3" x2="3" y2="13" />
          </svg>
        </button>
      )}
    </div>
  )
}
